import { Language } from "../types";

export const languagesObject: Record<Language, string> = {
	[Language.Arabic]: 'ערבית',
	[Language.Hebrew]: 'עברית',
}

export const languagesArray: { id: string; value: string }[] =
	Object.keys(languagesObject).map((key) => ({ id: key, value: languagesObject[key as Language] }))
